import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Grid, useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useToggle } from '/@/hooks/toggle/useToggle';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import GDUDialog from '/@/views/frost-risk/frost-risk-map/components/modal';
import { cardSx } from '../..';

const FRReferences = ({ references, title, sx, source = _('Fuente: The Weather Company'), showInfoIcon = true }) => {
    const { open, toggle } = useToggle();
    const { open: openDialog, setClose, setOpen } = useToggle();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const isOpenedOnMobile = open || !isMobile;

    return (
        <Box sx={{ ...cardSx, ...sx }}>
            <Box
                sx={[
                    {
                        borderBottom: '1px lightgray solid',
                        p: 2,
                        width: { xs: '100%' },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    },
                    !isOpenedOnMobile && {
                        border: 'none',
                    },
                ]}
                onClick={() => toggle()}
            >
                <Title size='md' bolder>
                    <Box sx={[{ display: 'flex', gap: 2, p: 0, alignItems: 'center' }]}>
                        <span>{_('Referencias')}</span>
                        {showInfoIcon && (
                            <IconButton onClick={setOpen} sx={[{ p: 0 }]} size={'small'}>
                                <InfoIcon color='primary' />
                            </IconButton>
                        )}
                    </Box>
                </Title>
                <GDUDialog open={openDialog} onClose={setClose} />
                <KeyboardArrowDownIcon
                    sx={[
                        { display: { md: 'none' }, pointer: 'cursor', pointerEvents: 'all' },
                        !isOpenedOnMobile && {
                            transform: 'rotate(180deg)',
                        },
                    ]}
                />
            </Box>
            <Box
                sx={[
                    { display: 'flex', flexDirection: 'column', width: '100%', p: 2 },
                    !isOpenedOnMobile && { display: 'none' },
                ]}
            >
                <Box sx={{ mb: 1 }}>
                    <Title size='sm'>{title}</Title>
                </Box>
                {references.map(({ label, secondLabel, color }, i) => (
                    <Grid
                        container
                        key={i}
                        justifyContent='space-between'
                        sx={{ background: { xs: `${color}1A`, md: 'none' } }}
                    >
                        <Grid
                            item
                            sx={[
                                { background: color, width: '15px' },
                                i === 0 && {
                                    borderRadius: '2px 2px 0px 0px',
                                },
                                i === references.length - 1 && {
                                    borderRadius: '0px 0px 2px 2px',
                                },
                            ]}
                            xs={2}
                        />
                        {secondLabel && (
                            <Grid item sx={{ alignSelf: 'center' }} xs={4}>
                                <Title size='md'>{secondLabel}</Title>
                            </Grid>
                        )}
                        <Grid item sx={{ alignSelf: 'center' }} xs={secondLabel ? 4 : 9}>
                            <Title size='md'>{label}</Title>
                        </Grid>
                    </Grid>
                ))}
                <Box sx={{ mt: 1 }}>
                    <Title size='sm'>{source}</Title>
                </Box>
            </Box>
        </Box>
    );
};

export default FRReferences;
